module.exports = __webpack_public_path__ + "src/images/products/trendsetter/114_Off-Whtie Canvas Emoji High-Top Sneakers.png";